<template>
  <div class="slidecontainer">
    <div class="slider-steps">
      <span>1</span>
      <span>10</span>
    </div>
    <input
      v-model="value"
      type="range"
      min="1"
      max="10"
      step="0.1"
      value="5.5"
      class="slider"
      :disabled="isDisabled"
      @input="changeValue"
    >
  </div>
</template>

<script>
  export default {
    name: 'Slider',
    props: {
      isDisabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        value: 5.5
      }
    },
    methods: {
      changeValue () {
        this.$emit('changedValue', this.value)
      }
    }
  }
</script>

<style lang="scss">
  .slider-steps{
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .slidecontainer {
    width: 100%;
  }

  .slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 10px;
    background: lighten($primary-color, 10%);
    border-radius: 4px;
    outline: none;
    opacity: 1;
    -webkit-transition: .2s;
    transition: opacity .2s;

    &:hover{
      cursor: pointer;
      background: lighten($primary-color, 20%);

      &::-webkit-slider-thumb, &::-moz-range-thumb {
        -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
      }
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 25px;
      height: 25px;
      background: $yellow;
      cursor: pointer;
      border: 2px solid $primary-color;
      border-radius: 50%;
    }

    &::-moz-range-thumb {
      width: 25px;
      height: 25px;
      background: $yellow;
      cursor: pointer;
      border: 2px solid $primary-color;
      border-radius: 50%;
    }

    &[disabled]{
      background: $gray-light;
      &::-webkit-slider-thumb{
        background: $gray;
        cursor: not-allowed;
        border: 2px solid $gray-dark;
      }
      &::-moz-range-thumb {
        background: $gray;
        cursor: not-allowed;
        border: 2px solid $gray-dark;
      }
    }
  }

</style>
